import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/patrolProblemReport',
    meta: { title: '问题上报记录' },
    component: Layout,
    redirect: '/patrolProblemReport/list',
    children: [
      {
        path: 'list',
        meta: { title: '问题上报记录', activeMenu: '/patrolProblemReport' },
        component: () => import('@/views/patrolProblemReport/PatrolProblemReport.vue')
      },
      {
        path: 'detail',
        meta: { title: '问题上报详情', activeMenu: '/patrolProblemReport' },
        component: () => import('@/views/patrolProblemReport/PatrolProblemReportDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增问题上报', activeMenu: '/patrolProblemReport' },
        component: () => import('@/views/patrolProblemReport/PatrolProblemReportAdd.vue')
      },
      {
        path: 'feedback',
        meta: { title: '问题上报反馈', activeMenu: '/patrolProblemReport' },
        component: () => import('@/views/patrolProblemReport/PatrolProblemReportDetail.vue')
      }

    ]
  }

]
